import React, { useEffect, useRef, useState } from "react";

import logo from "../../assets/logo.png";

import more from "../../assets/more.png";

import { Link } from "react-router-dom";

import { useNavigate } from "react-router-dom";

import "./header.css";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";


const useDropdown = () => {

  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const closeDropdown = () => setIsOpen(false);

  return { isOpen, toggleDropdown, closeDropdown };

};



export const Header = () => {

  const navigate = useNavigate();

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const [mobileServicesOpen, setMobileServicesOpen] = useState(false);

  const { isOpen: isServicesOpen, toggleDropdown: toggleServicesDropdown, closeDropdown: closeServicesDropdown } = useDropdown();

  const servicesDropdownRef = useRef(null);



  const handleHtmlClick = (event) => {

    if (

      servicesDropdownRef.current &&

      !servicesDropdownRef.current.contains(event.target)

    ) {

      closeServicesDropdown();

    }

  };

  useEffect(() => {

    document.addEventListener("click", handleHtmlClick);

    return () => {

      document.removeEventListener("click", handleHtmlClick);

    };

  }, []);



  const handleServiceClick = (route) => {

    navigate(route);

    closeServicesDropdown();

    setMobileMenuOpen(false);

    setMobileServicesOpen(false);

  };



  const handleNavClick = (route) => {

    navigate(route);

    setMobileMenuOpen(false);

    setMobileServicesOpen(false);

  };



  return (

    <div className="heade">

      <img

        src={logo}

        alt="logo"

        className="logo"

        onClick={() => navigate("/")}

        style={{ cursor: "pointer" }}

      />

      {/* Hamburger icon for mobile */}

      {!mobileMenuOpen && (

        <div className="mobile-hamburger" onClick={() => setMobileMenuOpen(true)}>

          <MenuIcon style={{ fontSize: 32, cursor: "pointer" }} />

        </div>

      )}

      {/* Mobile overlay menu */}

      {mobileMenuOpen && (

        <div className="mobile-overlay">

          <div className="mobile-overlay-header">

            <img

              src={logo}

              alt="logo"

              className="logo"

              onClick={() => handleNavClick("/")}

              style={{ cursor: "pointer" }}

            />

            <CloseIcon

              style={{ fontSize: 32, cursor: "pointer" }}

              onClick={() => setMobileMenuOpen(false)}

            />

          </div>

          <ul className="mobile-menu-list">

            <li onClick={() => handleNavClick("/")}>Home</li>

            <li onClick={() => handleNavClick("/about-us")}>About Us</li>

            <li>

              <div

                className="mobile-services-toggle"

                onClick={() => setMobileServicesOpen((open) => !open)}

                style={{ gap: 0, display: 'flex', alignItems: 'center' }}

              >

                <span style={{ marginRight: 0 }}>Services</span><ExpandMoreIcon style={{ transform: mobileServicesOpen ? "rotate(180deg)" : "none", marginLeft: 0 }} />

              </div>

              {mobileServicesOpen && (

                <ul className="mobile-services-submenu">

                  <li onClick={() => handleServiceClick("/digital-marketing")}>Digital marketing</li>

                  <li onClick={() => handleServiceClick("/web-designing")}>Web Designing</li>

                  {/* <li onClick={() => handleServiceClick("/seo-services")}>SEO Services</li>

                  <li onClick={() => handleServiceClick("/smm-services")}>SMM Services</li>

                  <li onClick={() => handleServiceClick("/sem-services")}>SEM Services</li> */}

                  <li onClick={() => handleServiceClick("/graphic-designing")}>Graphic Designing</li>

                </ul>

              )}

            </li>

            <li onClick={() => handleNavClick("/careers")}>Careers</li>

            <li onClick={() => handleNavClick("/blog")}>Blog</li>

            <li onClick={() => handleNavClick("/contact-us")}>Contact Us</li>

          </ul>

        </div>

      )}

      {/* Desktop menu */}

      <div className="head-one">

        <ul>

          <Link className="link" to="/">Home</Link>

          <Link className="link" to="/about-us">About Us</Link>

          <li ref={servicesDropdownRef}>

            <a href="#" className="heade-services" onClick={toggleServicesDropdown}>

              Services <ExpandMoreIcon />

            </a>

            <ul className="nav-dropdown" style={{ display: isServicesOpen ? "block" : "none" }}>

              <li onClick={() => handleServiceClick("/digital-marketing")}> <a href="#" className="dgi-lin">Digital marketing</a> </li>

              <li onClick={() => handleServiceClick("/web-designing")}> <a href="#" className="dgi-lin">Web Designing</a> </li>

              {/* <li onClick={() => handleServiceClick("/seo-services")}> <a href="#" className="dgi-lin">SEO Services</a> </li>

              <li onClick={() => handleServiceClick("/smm-services")}> <a href="#" className="dgi-lin">SMM Services</a> </li>

              <li onClick={() => handleServiceClick("/sem-services")}> <a href="#" className="dgi-lin">SEM Services</a> </li> */}

              <li onClick={() => handleServiceClick("/graphic-designing")}> <a href="#" className="dgi-lin">Graphic Designing</a> </li>

            </ul>

          </li>

          <Link className="link" to="/careers">Careers</Link>

          <Link className="link" to="/blog">Blog</Link>

        </ul>

        <Link className="btn-explore" to="/contact-us">Contact Us</Link>

      </div>

    </div>

  );

};